import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';

import { logger } from '@/utils/logger';

import type { ClientImportAlertsGateway } from '../infrastructure/client-import-alerts.gateway';
import { pendingCountRequested } from './client-import-alerts.actions';
import { clientImportAlertsActions } from './client-import-alerts.slice';

/**
 * WORKER: the sidebar badge. Silent on failure, like the List Feedbacks one: a
 * hint on every admin page must not raise an error banner. The last known
 * count stays.
 */
function* pendingCountWorker() {
  const gateway: ClientImportAlertsGateway = yield getContext('clientImportAlertsGateway');
  try {
    const count: number = yield call(gateway.loadPendingCount);
    yield put(clientImportAlertsActions.pendingCountLoaded(count));
  } catch (e) {
    logger.warn('Could not load the pending client import count', e);
  }
}

/** WATCHERS. */
export function* clientImportAlertsSaga() {
  yield all([takeLatest(pendingCountRequested.type, pendingCountWorker)]);
}
